import styled from '@emotion/styled'

import Button, { type ButtonProps } from '@segment/matcha/components/Button'

import * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const copy = {
  heading: `Learn more about customer insights and analytics with Segment`,
  description: `Twilio Segment is a critical tool in your tech stack to enable customer insights and analytics. Connect with a Segment expert to learn more about why 25,000+ companies choose Segment's CDP.`,
}

interface Button {
  text: string
  href: string
  variant: ButtonProps[`variant`]
}

const buttons: Button[] = [
  {
    text: `Get a demo`,
    href: `/demo`,
    variant: `filled`,
  },
  {
    text: `Pricing`,
    href: `/pricing`,
    variant: `outlined`,
  },
]

const LearnMore = () => {
  const pageConfig = usePageConfig()

  return (
    <Wrapper>
      <StyledSection variant="centered">
        <Section.Copy>
          <CopyText.Heading variant="h2" tag="h2">
            {copy.heading}
          </CopyText.Heading>
          <StyledDescription variant="pLarge" tag="p">
            {copy.description}
          </StyledDescription>

          <ButtonGroup>
            {buttons.map((button) => (
              <Button
                variant={button.variant}
                size="medium"
                color="primary"
                href={getAbsoluteUrl(button.href, pageConfig)}
                key={button.text}
              >
                {button.text}
              </Button>
            ))}
          </ButtonGroup>
        </Section.Copy>
      </StyledSection>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background: ${({ theme }) => theme.palette.neutrals.white[100]};
`

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    gap: 0;
  }
`

const StyledDescription = styled(CopyText.Description)`
  margin: 0;
`

const ButtonGroup = styled.div`
  margin-top: 30px;
  display: flex;
  align-items: center;
  gap: 16px;
`

export default LearnMore
